var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInterpolationRemove = function SvgInterpolationRemove(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7348 12.9998H23C23.5523 12.9998 24 12.552 24 11.9998C24 11.4475 23.5523 10.9998 23 10.9998H18.7348L19.7348 12.9998ZM14.2627 10.9998H7C6.44772 10.9998 6 11.4475 6 11.9998C6 12.552 6.44772 12.9998 7 12.9998H15.2627L14.2627 10.9998Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.553 5.10558C14.047 4.85859 14.6477 5.05881 14.8946 5.55279L20.8946 17.5528C21.1416 18.0468 20.9414 18.6474 20.4474 18.8944C19.9535 19.1414 19.3528 18.9412 19.1058 18.4472L13.1058 6.44722C12.8588 5.95324 13.059 5.35257 13.553 5.10558Z",
    fill: "#DD0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82843 14.8284C1.49509 13.4951 0.828427 12.8284 0.828427 12C0.828427 11.1716 1.49509 10.5049 2.82843 9.17157L3.17157 8.82843C4.50491 7.49509 5.17157 6.82843 6 6.82843C6.82843 6.82843 7.49509 7.49509 8.82843 8.82843L9.17157 9.17157C10.5049 10.5049 11.1716 11.1716 11.1716 12C11.1716 12.8284 10.5049 13.4951 9.17157 14.8284L8.82843 15.1716C7.49509 16.5049 6.82843 17.1716 6 17.1716C5.17157 17.1716 4.50491 16.5049 3.17157 15.1716L2.82843 14.8284Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInterpolationRemove);
export { ForwardRef as ReactComponent };